import { Slider } from "../slider/slider";


export class TvScheduleBar {
    defaultOptions = {
        wrapperClass:   'tv-schedule-bar__list',
        slideClass:     'tv-schedule-bar__item',
        slidesPerView:  'auto',
        slidesPerGroup: 1,
        freeMode:       true,
        grabCursor:     true,

        navigation: {
            prevEl: '.tv-schedule-bar__navigation--prev',
            nextEl: '.tv-schedule-bar__navigation--next'
        }
    };

    swiper;

    // staff
    structures;

    constructor(slider) {
        this.slider = slider;

        this.init();
    }

    init() {
        this.structures = $(this.slider).find('.tv-schedule-bar__slider');
        if (!this.structures.length) {
            return;
        }

        this.swiper = new Slider(this.structures, this.defaultOptions);

        this.getItemLive();

        return this.swiper;
    }

    // Función que muestra sincronizada la hora del sistema con "Programación".
    getItemLive() {
        // Hora actual.
        const date = new Date();
        const timestamp = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

        const bodyItems = $('.tv-schedule-bar__list').find('.tv-schedule-bar__item');
        if (!bodyItems.length) {
            return;
        }

        for (let i = 0; i < bodyItems.length; i++) {
            // Etiqueta donde contiene las horas de emisión.
            const scheduleHour = bodyItems[i].getElementsByTagName("b")[0].innerText.trim();
            let nextHour = scheduleHour;

            // Calculamos el siguiente elemento.
            if (i < bodyItems.length - 1) {
                nextHour = bodyItems[i+1].getElementsByTagName("b")[0].innerText.trim();
            }

            // Si la fecha de cierre es del día siguiente, no hay más que mirar
            if (!timestamp.split(':')[0].startsWith('0') // Estamos después de las 12
                && nextHour.split(':')[0].startsWith('0') // Acaba mañana
                && scheduleHour <= timestamp
                && nextHour < scheduleHour
            ) {
                // SI llegamos aquí es porque la fecha de inicio es anterior y la de fin es para mañana, así que es el item actual
                bodyItems[i].classList.add('tv-schedule-bar__item--active');

                // Se hace slide a la hora actual
                if (this.swiper) {
                    this.swiper.slideTo(i);
                }

                continue;
            }

            // Si llegamos aquí hacemos el control normal de las horas
            if (scheduleHour <= timestamp && timestamp < nextHour) {
                bodyItems[i].classList.add('tv-schedule-bar__item--active');

                // Se hace slide a la hora actual
                if (this.swiper) {
                    this.swiper.slideTo(i);
                }
            }
        }
    }
}
